// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/components/message/tooltips/FreeUserRoutingTooltip.tsx
import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import { getPaidUserSettingsUrl } from '../../../urls/getPaidUserSettingsUrl';
import { TrackUsageContext } from '../../../usage-tracking/contexts/TrackUsageContext';
// TODO: move this out of routing-rules
import { trackClickAssignSeats } from '../../../routing-rules/utils/event-handlers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FreeUserRoutingTooltip({
  children,
  userName
}) {
  const trackUsage = useContext(TrackUsageContext);
  const href = getPaidUserSettingsUrl(userName);
  const title = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.users-and-teams.tooltips.free-user-routing.description"
      })
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "routing-ui.users-and-teams.tooltips.free-user-routing.assign_seat_jsx",
      elements: {
        UILink
      },
      options: {
        onClick: () => trackUsage(trackClickAssignSeats()),
        external: true,
        href
      }
    })]
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    title: title,
    children: children
  });
}
FreeUserRoutingTooltip.displayName = 'FreeUserRoutingTooltip';
export default FreeUserRoutingTooltip;